export const DEFAULT_PAGE_SIZE = 15;
export const DEFAULT_PAGE = 0;
export const DEFAULT_THROTTLE_MS = 250;

export const MOBILE_DEVICES =
  'Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini';
